import React, { createContext, useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useAlert } from '../../alert/containers/AlertProvider'
import {
  getIntervenorListApi,
  createIntervenorApi,
  deleteIntervenorApi,
  banIntervenorApi,
  unbanIntervenorApi,
  getApiWilayasIPA,
  // getDairasOfWilayasApi,
  editIntervenorApi,
  // FilterIntervenantApi,
} from '../api'
import { useTranslation } from 'react-i18next'

export const IntervenorContext = createContext()

// mem
const initialPagination = { currentPage: 0, take: 10, skip: 0, total: 0 }

export const initialFilter = {
  email: '',
  phoneNumber: '',
  entityTypeIds: [],
  wilayaIds: [],
  dairaIds:[],
  communeIds: [],
}

export const IntervenorProvider = ({ children }) => {
  const { showAlert } = useAlert()
  const [isLoading, setIsLoading] = useState(false)

  const [intervenorList, setIntervenorList] = useState([])

  //
  const [apiWilayaList, setapiWilayaList] = useState([])
  const [apiRawWilayaList, setapiRawWilayaList] = useState([])

  //
  // const [apiDairaName, setapiDairaName] = useState()
  // const [rawWilayaDairas, setrawWilayaDairas] = useState()

  // mem
  const [pagination, setPagination] = useState(initialPagination)

  const { t, i18n } = useTranslation()

  const [filter, setFilter] = useState(initialFilter)

  const handleFilter = (newFilter) => {
    handlePagination({ currentPage: 0, skip: 0 })
    setFilter(newFilter)
  }

  const getIntervenorList = async () => {
    try {
      const {
        email,
        phoneNumber,
        entityTypeIds,
        wilayaIds,
        dairaIds,
        communeIds
      } = filter
      // mem
      const { take, skip } = pagination
      setIsLoading(true)

      const requestFilter = {
        email,
        phoneNumber: phoneNumber.length > 3 ? phoneNumber : '',
        entityTypeIds: entityTypeIds.map(({ id }) => id),
        communeIds: communeIds.map(({ id }) => id),
        dairaIds: dairaIds.map(({ id }) => id),
        wilayaIds: communeIds.length === 0 ? wilayaIds.map(({ id }) => id) : [],
        take,
        skip,
      }

      // mem
      // const { data, headers } = await getIntervenorListApi({ take, skip })
      const { data, headers } = await getIntervenorListApi({ filter: requestFilter })

      setIntervenorList(data)

      //mem
      setPagination({ ...pagination, total: headers['x-total-count'] })
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const banIntervenor = async ({ email }) => {
    try {
      setIsLoading(true)

      await banIntervenorApi({ email })
      setIntervenorList(
        intervenorList.map((intervenor) => {
          if (intervenor.email === email) {
            return { ...intervenor, status: 2 }
          }
          return intervenor
        }),
      )
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const unbanIntervenor = async ({ email }) => {
    try {
      setIsLoading(true)

      await unbanIntervenorApi({ email })
      setIntervenorList(
        intervenorList.map((intervenor) => {
          if (intervenor.email === email) {
            return { ...intervenor, status: 1 }
          }
          return intervenor
        }),
      )
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  // mem
  const createIntervenor = async ({
    email,
    wilayaId,
    dairaId,
    communeId,
    entityName,
    entityType,
    phoneNumber,
    contactEmail,
    contactPhoneNumber,
  }) => {
    try {
      setIsLoading(true)

      // mem
      await createIntervenorApi({
        email,
        wilayaId,
        dairaId,
        communeId,
        entityName,
        entityType,
        phoneNumber,
        contactEmail,
        contactPhoneNumber,
      })

      // mem
      setIntervenorList([
        ...intervenorList,
        {
          email,
          wilayaId,
          dairaId,
          communeId,
          entityName,
          entityType,
          phoneNumber,
          contactEmail,
          contactPhoneNumber,
          creationDate: new Date(),
          status: 1,
        },
      ])

      showAlert({
        variant: 'success',
        message: "L'intervenant a bien été ajouté",
      })
    } catch (e) {
      if (e?.response?.data?.errorCode === 'DuplicateUserName') {
        showAlert({ message: t('showAlert.cet_email_existe_deja') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue') })
      }
    } finally {
      setIsLoading(false)
    }
  }

  // mem
  // const searchIntervenor = async ({ email }) => {
  //   try {
  //     setIsLoading(true)

  //     // mem
  //     let temp = await FilterIntervenantApi({
  //       email,
  //     })

  //     console.log(temp)

  //     // mem
  //     setIntervenorList(temp.data)

  //     showAlert({
  //       variant: 'success',
  //       message: 'Recherche succes!',
  //     })
  //   } catch (e) {
  //     showAlert({ message: t('showAlert.une_erreur_est_survenue') })
  //     // if (e?.response?.data?.errorCode === 'DuplicateUserName') {
  //     //   showAlert({ message: t('showAlert.cet_email_existe_deja') })
  //     // } else {
  //     //   showAlert({ message: t('showAlert.une_erreur_est_survenue') })
  //     // }
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  const deleteIntervenor = async ({ email }) => {
    try {
      setIsLoading(true)

      await deleteIntervenorApi({ email })
      setIntervenorList(
        intervenorList.filter((intervenor) => intervenor.email !== email),
      )
      showAlert({
        variant: 'success',
        message: "L'intervenant a bien été supprimé",
      })
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  //
  const getWilayaFromApi = async () => {
    try {
      setIsLoading(true)

      let temp = await getApiWilayasIPA()

      setapiRawWilayaList(temp.data)
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  //
  const mapWilayaPopOver = () => {
    let finalResult = []

    if (i18n.language === 'fr') {
      finalResult = apiRawWilayaList.map(({ id, name }) => ({
        id: id,
        label: name,
      }))
    } else {
      finalResult = apiRawWilayaList.map(({ id, name_ar }) =>
        id === -1 ? { id: -1, label: 'N/A' } : { id: id, label: name_ar },
      )
    }

    setapiWilayaList(finalResult)
  }

  // mem
  const handlePagination = ({
    take = pagination.take,
    skip = pagination.skip,
    currentPage = pagination.currentPage,
  }) => {
    setPagination({ ...pagination, take, skip, currentPage })
  }

  const editIntervenor = async ({
    email,
    wilayaId,
    dairaId,
    communeId,
    entityName,
    entityType,
    phoneNumber,
    contactEmail,
    contactPhoneNumber,
  }) => {
    try {
      setIsLoading(true)

      await editIntervenorApi({
        email,
        wilayaId,
        dairaId,
        communeId,
        entityName,
        entityType,
        phoneNumber,
        contactEmail,
        contactPhoneNumber,
      })

      // setIntervenorList([...intervenorList, { email, wilayaId, dairaId, communeId, entityName, entityType, phoneNumber, status: 1, contactEmail, contactPhoneNumber }])
      updateIntervenorList({
        email,
        wilayaId,
        dairaId,
        communeId,
        entityName,
        entityType,
        phoneNumber,
        contactEmail,
        contactPhoneNumber,
      })

      showAlert({
        variant: 'success',
        message: "L'intervenant a bien été modifié",
      })
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const updateIntervenorList = ({
    email,
    wilayaId,
    dairaId,
    communeId,
    entityName,
    entityType,
    phoneNumber,
    contactEmail,
    contactPhoneNumber,
  }) => {
    let intervenorIndex = intervenorList.findIndex(
      (intervenor) => intervenor.email == email,
    )
    intervenorList[intervenorIndex].email = email
    intervenorList[intervenorIndex].wilayaId = wilayaId
    intervenorList[intervenorIndex].dairaId = dairaId
    intervenorList[intervenorIndex].communeId = communeId
    intervenorList[intervenorIndex].entityName = entityName
    intervenorList[intervenorIndex].entityType = entityType
    intervenorList[intervenorIndex].phoneNumber = phoneNumber
    intervenorList[intervenorIndex].contactEmail = contactEmail
    intervenorList[intervenorIndex].contactPhoneNumber = contactPhoneNumber
  }

  const init = () => {
    setFilter({ ...initialFilter })
    setPagination({ ...initialPagination })
  }

  const providerValue = {
    intervenorList,
    banIntervenor,
    unbanIntervenor,
    createIntervenor,
    deleteIntervenor,
    getIntervenorList,
    isLoading,
    apiWilayaList,
    // mem
    pagination,
    handlePagination,
    editIntervenor,
    // searchIntervenor,
    filter,
    init,
    handleFilter,
    entityTypes: [
      { id: 7, label: t('entityType.epic') },
      { id: 8, label: t('entityType.apc') },
      { id: 9, label: t('entityType.de') },
      { id: 10, label: t('entityType.wilaya')},
      { id: 11, label: t('entityType.daira')}
    ]
  }

  /** */
  useEffect(() => {
    getIntervenorList()

    //
    getWilayaFromApi()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** */
  useEffect(() => {
    //
    mapWilayaPopOver()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiRawWilayaList])

  // mem
  useEffect(() => {
    getIntervenorList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination.take, pagination.skip])

  return (
    <IntervenorContext.Provider value={providerValue}>
      {children}
    </IntervenorContext.Provider>
  )
}

IntervenorProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useIntervenor = () => {
  const context = useContext(IntervenorContext)
  if (context === undefined) {
    throw new Error('useIntervenor must be used within an IntervenorProvider')
  }
  return context
}
